import { createReducer, on } from '@ngrx/store';
import { AclpermissionActions } from '../../actions/generations/aclpermission.actions';
import { GenerationActions } from '../../actions/generations/generation.actions';

export const aclpermissionFeatureKey = 'aclpermission';

export interface AclPermissionState {
  aclPermissions: any[];
}

export const initialState: AclPermissionState = {
  aclPermissions: []
};

export const aclpermissionReducer = createReducer(
  initialState,
  on(AclpermissionActions.setAclPermissions, (state, { aclPermissions }) => ({
    ...state,
    aclPermissions: [...aclPermissions]
  })),
  // Append at end to maintain stable row ordering (no jumping to top)
  on(AclpermissionActions.createAclPermissionSuccess, (state, { aclPermission }) => ({
    ...state,
    aclPermissions: [...state.aclPermissions, aclPermission]
  })),
  // In-place update preserving position
  on(AclpermissionActions.updateAclPermissionSuccess, (state, { aclPermission }) => ({
    ...state,
    aclPermissions: state.aclPermissions.map((p) => (p.sid === aclPermission.sid ? aclPermission : p))
  })),
  // Merge updated records into existing state (preserves unchanged records)
  on(AclpermissionActions.batchUpdateAclPermissionsSuccess, (state, { aclPermissions }) => {
    // Create a Map for fast lookup of updated records by sid
    const updatedRecordsMap = new Map(aclPermissions.map((acl) => [acl.sid, acl]));

    // Merge: replace matching records, keep others unchanged
    const mergedPermissions = state.aclPermissions.map((existingAcl) => {
      const updatedAcl = updatedRecordsMap.get(existingAcl.sid);
      return updatedAcl || existingAcl;
    });

    return {
      ...state,
      aclPermissions: mergedPermissions
    };
  }),
  on(GenerationActions.resetGeneration, () => ({ ...initialState })),
  on(AclpermissionActions.clearAclPermissionsState, () => ({ ...initialState }))
);

export { aclpermissionReducer as reducer };

